

export default {


    data() {
        return {
            dialogVisible: false,
            captchaBase: '',//验证码图片
            captchaCode: '',//验证码
            disabled: false
        }
    },
    mounted() {

        this.getCaptcha()



    },
    methods: {
        changeVisible(status) {

            this.dialogVisible = status
        },
        async getCaptcha() {
            if (this.dialogVisible == true) {

                let res = await this.$global.captcha()
                this.captchaBase = `data:image/png;base64,${res}`
            }

        },
        /** 把验证码交给资料表单提交；成功后由父组件关闭本弹窗 */
        async post() {
            if (this.disabled) {
                return
            }
            this.disabled = true
            this.$parent.captchaCode = this.captchaCode
            try {
                await this.$parent.triggerMethod()
            } finally {
                this.disabled = false
            }
        },
        closed() {
            // console.log(this.$parent.submitLoading, 'this.$parent.submitLoading')
            // this.$parent.submitLoading ? this.$parent.submitLoading = false : ''
        }
    }
}
